// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"b3dc8204","583":"589c1445","845":"475df314"}[chunkId] + ".chunk.js";
};